// import { bindActionCreators } from 'redux'
import Promise from 'bluebird'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { reduxForm, destroy, initialize, reset } from 'redux-form'
import { find } from 'lodash'
import { destroy as destroyOrder } from '../modules/order'
import { postMultiple } from '../modules/orders'
import {
  add as addToStaging,
  edit as editStaging,
  commit as commitStaging,
  destroy as destroyStaging,
  wipe as wipeStaging
} from '../modules/staging'

import moment from 'helpers/moment'
import { compareParseInt } from 'helpers/index'

import component from 'components/Orders'

const formName = 'new-order'
const fields = ['date', 'customer_id', 'product_id', 'uom_id', 'option_id', 'notes', 'qty']

const mapActionCreators = {
  editStaging,
  destroyStaging,
  wipeStaging,
  destroyOrder
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(mapActionCreators, dispatch),
  dispatch
})

// This allows for me to have state, dispatch, and props, so I can put customer onto the staging order.
const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { dispatch } = dispatchProps

  const newProps = {
    commitStaging: (data) => {
      if (!data) return

      dispatch(postMultiple(data)).then(result => {
        if (!result.error) {
          dispatch(commitStaging())
        }
      })

      // reset the form now
      dispatch(reset(formName))
      dispatch(destroy(formName))
      dispatch(initialize(formName, stateProps.initialValues, fields))
    },
    onSubmit: (data) => {
      let initialValues = Object.assign({},
        // merge in submitted customer/route/date to keep those values on new form
        { date: data.date, customer_id: data.customer_id },
        stateProps.initialValues, // override
        { product_id: undefined, option_id: undefined, uom_id: undefined } // don't allow query to set product
      )

      let getRelation = (collectionName, modelId, foreignKey = 'id') => {
        const collection = stateProps[collectionName] || []
        return collection.find(model => model && compareParseInt(model[foreignKey], modelId)) || {}
      }

      // a-typical unlike below, non-programatic as this collection name is pricelist instead of products
      if (data.product_id) {
        data.product = getRelation('pricelist', data.product_id, 'product_id')
      }

      ['customer', 'uom', 'option'].forEach(relation => {
        if (!data[`${relation}_id`]) return

        data[relation] = getRelation(`${relation}s`, data[`${relation}_id`])
      })

      // SPECIAL: Automatically route the order.
      data.route = {}
      if (data.customer && data.customer.routes && data.customer.routes.length) {
        let route = (data.customer.routes || []).find(o =>
          compareParseInt(o.day_of_week, moment(data.date).format('d'))
        ) || (data.customer.routes || []).find(o => o.day_of_week === '*')

        if (route && route.name) data.route = route
      }

      data.is_staging = true

      dispatch(addToStaging(data))
      dispatch(reset(formName))
      dispatch(destroy(formName))
      dispatch(initialize(formName, initialValues, fields))

      return Promise.resolve(data)
    }
  }

  return Object.assign({}, ownProps, stateProps, dispatchProps, newProps) // further right = override
}

const mapStateToProps = (state, ownProps) => {
  let obj = {
    staging: state.staging,
    orders: state.orders,
    order: state.order,
    customers: state.customers,
    pricelist: state.pricelist,
    options: state.options,
    uoms: state.uoms,
    date: 'today',
    initialValues: {
      date: moment('today').format('YYYY-MM-DD')
    },
    isAdmin: state.auth && state.auth.isAdmin,
    user: state.auth && state.auth.user,

    routeIntention: ownProps.route && ownProps.route.routeIntention || 'form'
  }

  if (ownProps.location.query.date) {
    obj.date = ownProps.location.query.date
    obj.initialValues.date = moment(ownProps.location.query.date).format('YYYY-MM-DD')
  } else if (ownProps.params.date) {
    obj.date = ownProps.params.date
    obj.initialValues.date = moment(ownProps.params.date).format('YYYY-MM-DD')
  }

  // set the initial product from location query (eg. orders/new/?produt_id=42)
  if (ownProps.location.query.product_id) {
    let productId = parseInt(ownProps.location.query.product_id, 10)
    let pricelistProduct = state.pricelist && state.pricelist.length &&
      productId && find(state.pricelist, { product_id: productId })

    if (pricelistProduct) {
      obj.initialValues.product_id = obj.initialValues.product_id === undefined && pricelistProduct.product_id
      obj.initialValues.option_id = obj.initialValues.option_id === undefined && pricelistProduct.default_option_id
      obj.initialValues.uom_id = obj.initialValues.uom_id === undefined && pricelistProduct.default_uom_id
    }
  }

  if (state.auth && state.auth.isAdmin) {
    obj.routes = state.routes && typeof state.routes.sort === 'function' &&
      state.routes.sort((a, b) => {
        // put Default at top of list, then alphanumerical sorting
        if (a.day_of_week === '*') return -10
        if (b.day_of_week === '*') return 10
        return a.day_of_week - b.day_of_week
      })
  }

  if (obj.customers && obj.customers.length === 1) {
    obj.initialValues.customer_id = obj.customers[0].id
  }

  return obj
}

const form = reduxForm({
  form: formName,
  fields,
  touchOnChange: true,
  validate (state) {
    var errors = {}
    if (!state.date) errors.date = 'Please select a date for the order.'
    if (!state.customer_id) errors.customer_id = 'Please select a customer.'
    if (!state.product_id) errors.product_id = 'Please select a product.'
    if (!state.qty) errors.qty = 'Please enter a quantity.'
    else if (!parseFloat(state.qty) || parseFloat(state.qty) <= 0) errors.qty = 'Please enter a valid quantity.'
    if (!state.uom_id) errors.uom_id = 'Please select a unit of measure.'
    if (state.notes && state.notes.length > 50) errors.notes = 'Order Notes should be a maximum 50 characters.'

    return errors
  }
})(component)

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(form)



// WEBPACK FOOTER //
// ./src/routes/Orders/containers/OrdersContainer.js